
export function getBackgroundPicture () {
  const max = 67
  const random = String(Math.floor(Math.random() * max)).padStart(3, '0')
  // console.log(`random is ${random}`)
  return require(`@/assets/background/background${random}.jpg`)
}
